<template>
  <div class="page_nav">
    <div class="page_games">
      <div
        v-for="gm in theTop4Games"
        :key="gm.gameId"
        class="page_game"
        :class="{ 
          page_game_active: gm.gameId === activeGameId,
          active_text: gm.gameId === activeGameId
        }"
        @click="handleChangeActiveGame(gm)"
      >
        <div
          class="page_game_icon bg_contain"
          :style="{
            backgroundImage: `url(${gm.logo})`
          }"
        >
          <div
            v-if="gm.gameId === activeGameId"
            class="page_game_icon_cover bg_contain"
            :style="{
              backgroundImage: `url(${CDN_URL}/selected.png)`
            }"
          >

          </div>
        </div>
        <div class="page_game_name scale09_center van-ellipsis">{{ gm.gameName }}</div>
      </div>
    </div>
    <div v-if="gameList.length > 4" class="page_more d_flex_col flex_a_c" @click="triggerMoreGame(true)">
      <div
        class="page_game_icon bg_contain"
        :style="{
          backgroundImage: `url(${rootCDNUrl}/more.png)`
        }"
      ></div>
      <div class="page_game_name scale09_center active_text">更多游戏</div>
    </div>
  </div>
</template>

<script>
import { CDN_URL_1 } from "@/config";
export default {
  props: {
    gameList: {
      type: Array,
      default: () => [],
    },
    activeGameId: {
      type: [Number, String],
      default: -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () { 
    return {
      rootCDNUrl: 'https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_wxDrawLottery',
      CDN_URL: CDN_URL_1 + '/box_zillionaire',
      visible: false,
    }
  },
  computed: {
    theTop4Games () {
      const gList = this.gameList
      if (!Array.isArray(gList) || !gList.length) return []
      const maxCount = 4
      const currentIdx = gList.findIndex(it => it.gameId === this.activeGameId)
      const res = [gList[currentIdx]]
      gList.forEach(it => {
        if (res.length === maxCount) return
        if (it.gameId === this.activeGameId) return
        res.push(it)
      })
      return res
    },
  },
  methods: {
    triggerMoreGame (v) {
      if (this.disabled) return
      this.$emit('more')
    },
    handleChangeActiveGame (game) {
      if (this.disabled) return
      this.$emit('changeActiveGame', game)
    },
  },
}
</script>

<style scoped lang="scss">
.page_nav {
  position: relative;
  min-height: 84px;
  padding: 20px 64px 6px 24px;
  background: rgba(255, 255, 255, .45);
  border-radius: 6px;
}
.page_more {
  position: absolute;
  // top: 50%;
  bottom: 7px;
  right: 12px;
  // transform: translateY(-50%);
}
.page_games {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  width: 256px;
}
.page_game {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 64px;
}
.page_game_icon {
  width: 46px;
  height: 46px;
  margin-bottom: 6px;
  transition: 0.15s all ease;
  border-radius: 6px;
  flex-shrink: 0;
  filter: drop-shadow(-1px 1px 3px #333);
  .page_game_icon_cover {
    width: 54px;
    height: 54px;
    position: absolute;
    top: -4px;
    left: -4px;
  }
}
.page_game_name {
  width: 115%;
  font-size: 12px;
  text-align: center;
  // white-space: nowrap;
}
.page_game_active {
  opacity: 1;
  .page_game_icon {
    transform: scale(1.26);
    transform-origin: 50% 100%;
    border-radius: 10px;
  }
  .page_game_name {
    width: 130%;
    color: #FAD923;
  }
}
</style>